import React, { useEffect, useState } from 'react';

import { Dayjs } from 'dayjs';

import { Box, Grid, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface IRangePicker {
    /**
     * Label no input de data inicial
     */
    labelInicial: string,
    /**
     * Label no input de data final
     */
    labelFinal: string,
    /**
     * Valor inicial do input data inicial
     */
    valueInicial?: Dayjs | null,
    /**
     * Valor inicial do input data inicial
     */
    valueFinal?: Dayjs | null,
    /**
     * Diz se ambos os campos vai estar desabilitado
     */
    disabled?: boolean,
    /**
     * Datas selecionadas ([{inicial}, {final}])
     */
    retornoData: (dataInicial: Dayjs | null, dataFinal: Dayjs | null) => void
}


/**
 * 
 * retornoData={(dataInicial, dataFinal) => { }}
 */
export const RangePicker: React.FC<IRangePicker> = ({ labelInicial = "Data Inicial", labelFinal = "Data Final", valueInicial = null, valueFinal = null, disabled = false, retornoData }) => {

    const [dataInicial, setDataInicial] = useState<Dayjs | null>(valueInicial);
    const [dataFinal, setDataFinal] = useState<Dayjs | null>(valueFinal);

    useEffect(() => {
        retornoData(dataInicial, dataFinal);
    }, [dataInicial, dataFinal]);

    return (

        <Box>

            <Grid container direction="column" spacing={2}>
                <Grid container item direction="row" spacing={2}>

                    <Grid item width={'47.5%'}>

                        <DatePicker
                            label={labelInicial}
                            value={valueInicial}
                            onChange={(newValue) => setDataInicial(newValue)}
                            slotProps={{ textField: { fullWidth: true } }}
                            disabled={disabled}
                        />

                    </Grid>

                    <Grid item width={'5%'} sx={{ m: 'auto' }}> {/* mt: 'auto', mb: 'auto', ml: 'auto', mr: 'auto' }}> */}

                        <Typography>até</Typography>

                    </Grid>

                    <Grid item width={'47.5%'}>

                        <DatePicker
                            label={labelFinal}
                            minDate={dataInicial}
                            value={valueFinal}
                            onChange={(newValue) => setDataFinal(newValue)}
                            slotProps={{ textField: { fullWidth: true } }}
                            disabled={dataInicial === null || disabled}
                        />

                    </Grid>

                </Grid>
            </Grid>

        </Box>

    )
}